import { render, staticRenderFns } from "./list-details.vue?vue&type=template&id=cf128d3e&scoped=true"
import script from "./list-details.vue?vue&type=script&lang=js"
export * from "./list-details.vue?vue&type=script&lang=js"
import style0 from "./list-details.vue?vue&type=style&index=0&id=cf128d3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf128d3e",
  null
  
)

export default component.exports